@layer module {
.custom-dropdown-wrapper {
            position: relative;
            display: inline-block;
    }

.icon-container {
            cursor: pointer;
            display: flex;
            justify-content: center;
    }

.dropdown-button {
            border: 1px solid;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: space-between;
            white-space: nowrap;
    }

.dropdown-content {
            z-index: 1001;
            position: absolute;
            display: none;
    }

.dropdown-content.opened {
            display: inline-block;
    }

.dropdown-content :global(.dropdown-container) {
            border-width: 1px;
            border-style: solid;
            display: flex;
            flex-flow: column nowrap;
    }

.dropdown-content :global(.dropdown-container) > * {
            cursor: pointer;
            display: flex;
            justify-content: flex-start;
            align-items: center;
    }

.dropdown-content :global(.dropdown-container) > * + * {
            border-top-width: 1px;
            border-top-style: solid;
    }
} // layer module










@layer app {
.icon-container {
            width: 100%;
    }

.dropdown-button {
            border-radius: $size-18;
            height: $size-36;
            padding: 0 $size-14;
    }

.dropdown-button .icon {
            margin-right: $size-8;
    }

.dropdown-button .chevron {
            margin-left: $size-8;
    }

.dropdown-content {
            top: calc(100% + $size-8);
            right: 0;
    }

.dropdown-content :global(.dropdown-container) {
            border-radius: $size-5;
            width: $size-160;
            padding: $size-10 $size-20;
    }

.dropdown-content :global(.dropdown-container) > * {
            gap: $size-10;
            padding: 0 $size-10;
    }

.dropdown-content.alternative {
            top: $size-30;
    }

.dropdown-content.drop-up {
            top: auto;
            bottom: calc(100% + $size-8);
    }

.dropdown-content.align-start {
            left: 0;
            right: auto;
    }

      @media (max-width: 767px) {
                .dropdown-content.alternative {
                        left: 0;
                    }
          }

      @media (min-width: 768px) {
                .dropdown-content.alternative {
                        right: 5%;
                    }
          }

.dropdown-button {
            background-color: var(--bg-surface);
            border-color: var(--border-default);
            color: var(--text-primary);
            font-size: var(--font-size-sm);
            font-style: normal;
            font-weight: 500;
            line-height: $size-17;
    }

.dropdown-button:hover,
.dropdown-button:focus-visible,
.dropdown-button.opened {
            background-color: var(--page-canvas);
            border-color: var(--border-strong);
    }

.dropdown-content :global(.dropdown-container) {
            background: var(--banky-white);
            border-color: var(--border-neutral-light);
    }

.dropdown-content :global(.dropdown-container) > * {
            border-top-color: var(--border-neutral-light);
            font-size: var(--font-size-sm);
            font-weight: 400;
            line-height: $size-10;
    }
} // layer app
